/* eslint-disable react/prop-types */
import { FormattedMessage } from "react-intl";
import { Column } from "react-table";
import { formatDate, DateTimeFormat } from "helpers/dateTimeHelper";
import { formatMaskedToken } from "helpers/formatMaskedToken";
import Button from "components/v2/Button/Button";

interface DeveloperApiToken {
  id: number;
  name: string;
  key_suffix: string;
  created: string;
  created_by: string;
  revoked_at: string | null;
}

interface TokenColumnsOptions {
  onRevoke: (value: DeveloperApiToken) => void;
}

function getDeveloperApiTokenColumns({ onRevoke }: TokenColumnsOptions) {
  const columns: Column<any>[] = [
    {
      id: "name",
      Header: () => <FormattedMessage id="settings.developerApiTokens.columns.name" defaultMessage="Name" />,
      accessor: "name",
      Cell: ({ value, row }) => <span className={row.original.revoked_at ? "text-tertiary" : ""}>{value || "—"}</span>,
      width: "34%",
    },
    {
      id: "created_by",
      Header: () => <FormattedMessage id="settings.developerApiTokens.columns.createdBy" defaultMessage="Created by" />,
      accessor: "created_by",
      Cell: ({ value, row }) => <span className={row.original.revoked_at ? "text-tertiary" : ""}>{value || "—"}</span>,
      width: "30%",
    },
    {
      id: "created",
      Header: () => <FormattedMessage id="settings.developerApiTokens.columns.dateCreated" defaultMessage="Date created" />,
      accessor: "created",
      Cell: ({ value, row }) => (
        <span className={row.original.revoked_at ? "text-tertiary" : ""}>
          {value ? formatDate(value, DateTimeFormat.dateFormat) : "—"}
        </span>
      ),
      width: "16%",
    },
    {
      id: "key_suffix",
      Header: () => <FormattedMessage id="settings.developerApiTokens.columns.token" defaultMessage="Token" />,
      accessor: "key_suffix",
      Cell: ({ value, row }) => (
        <span className={`font-monospace ${row.original.revoked_at ? "text-tertiary" : ""}`}>
          {formatMaskedToken(value)}
        </span>
      ),
      width: "10%",
    },
    {
      id: "action",
      Header: () => <FormattedMessage id="settings.developerApiTokens.columns.action" defaultMessage="Action" />,
      accessor: "revoked_at",
      Cell: ({ value, row }) => {
        if (value) {
          return (
            <span className="text-tertiary text-sm">
              <FormattedMessage id="settings.developerApiTokens.revoked" defaultMessage="Revoked" />
            </span>
          );
        }
        return (
          <Button
            label={<FormattedMessage id="settings.developerApiTokens.revoke" defaultMessage="Revoke" />}
            onClick={() => onRevoke(row.original)}
            variant="link-error"
            size="sm"
          />
        );
      },
      width: "10%",
      disableSortBy: true,
    },
  ];

  return columns;
}

export default getDeveloperApiTokenColumns;
